module.exports = __webpack_public_path__ + "img/btnimg.0e8ae500.png";